import { IValidationResult } from '../../interfaces/validation.interface';

export default class WordCountValidator {
  constructor(
    private wordCount: number,
    private tag: DefaultTags,
    private countries: string[],
  ) {}

  validate(): IValidationResult {
    return this.checkWordsRestrictions();
  }

  checkWordsRestrictions = (): IValidationResult => {
    const validationResult: IValidationResult = { errors: [], warnings: [] };

    if (this.countries.includes('JP')) return validationResult;

    const minimumWordsBindings: { [key: string]: number } = {
      ar: 1000,
      gm: 500,
      nw: 300,
    };

    if (this.wordCount < (minimumWordsBindings[this.tag] || -1)) {
      validationResult.errors.push({
        message: `In ${this.getFullNameFromTag(
          this.tag,
        )}, the number of words must be at least ${
          minimumWordsBindings[this.tag]
        } (${this.wordCount} currently)`,
      });
    }

    return validationResult;
  };

  private getFullNameFromTag(tag: DefaultTags) {
    const tagNameBindings = {
      ar: 'Article',
      nw: 'News',
      gm: 'Games',
      pg: 'Pagination',
      tl: 'Translator',
    };

    return tagNameBindings[tag];
  }
}
